window.bootstrap = require("bootstrap");
window.lity = require("lity");

window.Splide = require("@splidejs/splide/dist/js/splide.js");

async function loadWidgetTextModulesOnDemand(isEditMode) {
  if (document.querySelectorAll(".widget-text").length > 0) {
    const textWidgetModule = await import(
      /* webpackChunkName: "textWidgetModule" */ "./widgets/textWidget.js"
    );
    textWidgetModule.default.init(isEditMode);
  }
}

async function loadWidgetBannerCarouselModulesOnDemand(isEditMode) {
  if (document.querySelectorAll(".widget-banner-carousel").length > 0) {
    const carouselWidgetModule = await import(
      /* webpackChunkName: "bannerCarouselWidget" */ "./widgets/bannerCarouselWidget.js"
    );
    carouselWidgetModule.default.init(isEditMode);
  }
}

async function loadWidgetTabsModulesOnDemand(isEditMode) {
  if (document.querySelectorAll(".section-tabs").length > 0) {
    const tabsWidgetModule = await import(
      /* webpackChunkName: "tabsSection" */ "./widgets/tabsSection.js"
    );
    tabsWidgetModule.default.init(isEditMode);
  }
}

async function loadWidgetThreeTabsModulesOnDemand(isEditMode) {
  if (document.querySelectorAll(".section-three-tabs").length > 0) {
    const threeTabsWidgetModule = await import(
      /* webpackChunkName: "threeTabsSection" */ "./widgets/threeTabsSection.js"
    );
    threeTabsWidgetModule.default.init(isEditMode);
  }
}

async function loadWidgetAccordionModulesOnDemand(isEditMode) {
  if (document.querySelectorAll(".accordion").length > 0) {
    const tabsWidgetModule = await import(
      /* webpackChunkName: "accordionSection" */ "./widgets/accordionSection.js"
    );
    tabsWidgetModule.default.init(isEditMode);
  }
}

async function loadWidgetBannerCarouselSectionModulesOnDemand(isEditMode) {
  if (document.querySelectorAll(".widget-carousel-section").length > 0) {
    const carouselWidgetModule = await import(
      /* webpackChunkName: "bannerCarouselSectionWidget" */ "./widgets/bannerCarouselSectionWidget.js"
    );
    carouselWidgetModule.default.init(isEditMode);
  }
}

async function loadWidgetCardsModulesOnDemand(isEditMode) {
  if (document.querySelectorAll(".widget-cards").length > 0) {
    const carouselWidgetModule = await import(
      /* webpackChunkName: "cardsWidget" */ "./widgets/cardsWidget.js"
    );
    carouselWidgetModule.default.init(isEditMode);
  }
}

async function loadWidgetQuickLinksModulesOnDemand(isEditMode) {
  if (document.querySelectorAll(".widget-card").length > 0) {
    const quickLinksWidgetModule = await import(
      /* webpackChunkName: "quickLinksWidget" */ "./widgets/quickLinksWidget.js"
    );
    quickLinksWidgetModule.default.init(isEditMode);
  }
}

async function loadWidgetFinLitSessionsModulesOnDemand(isEditMode) {
  if (document.querySelectorAll(".widget-finlit-sessions").length > 0) {
    const finlitSessionsWidgetModule = await import(
      /* webpackChunkName: "finlitSessionsWidget" */ "./widgets/finlitSessionsWidget.js"
    );
    finlitSessionsWidgetModule.default.init(isEditMode);
  }
}

async function loadWidgetChapterEventsModulesOnDemand(isEditMode) {
  if (document.querySelectorAll(".widget-chapter-events").length > 0) {
    const chapterEventsWidgetModule = await import(
      /* webpackChunkName: "chapterEventsWidget" */ "./widgets/chapterEventsWidget.js"
    );
    chapterEventsWidgetModule.default.init(isEditMode);
  }
}

async function loadWidgetSavingsBenefitModulesOnDemand(isEditMode) {
  if (document.querySelectorAll(".widget-savings-benefits").length > 0) {
    const savingsBenefitWidgetModule = await import(
      /* webpackChunkName: "savingsBenefitsWidget" */ "./widgets/savingsBenefitsWidget.js"
    );
    savingsBenefitWidgetModule.default.init(isEditMode);
  }
}

async function loadWidgetLatestNewsModulesOnDemand(isEditMode) {
  if (document.querySelectorAll(".widget-latest-news").length > 0) {
    const latestNewsWidgetModule = await import(
      /* webpackChunkName: "latestNewsWidget" */ "./widgets/latestNewsWidget.js"
    );
    latestNewsWidgetModule.default.init(isEditMode);
  }
}

async function loadWidgetVideoTabsModulesOnDemand(isEditMode) {
  if (
    document.querySelectorAll(".section-video-tabs .main-splide").length > 0
  ) {
    const tabsWidgetModule = await import(
      /* webpackChunkName: "videoTabsWidget" */ "./widgets/videoTabsWidget.js"
    );
    tabsWidgetModule.default.init(isEditMode);
  }
}

async function scrollableLinksBackgroundModulesOnDemand(isEditMode) {
  if (
    document.querySelectorAll(".widget-scrollable-links-background").length > 0
  ) {
    const scrollableLinksBackground = await import(
      /* webpackChunkName: "scrollableLinksBackgroundWidget" */ "./widgets/scrollableLinksBackgroundWidget.js"
    );
    scrollableLinksBackground.default.init(isEditMode);
  }
}

async function cardsCarouselModulesOnDemand(isEditMode) {
  if (
    document.querySelectorAll(".widget-cards-carousel").length > 0
  ) {
    const cardsCarousel = await import(
      /* webpackChunkName: "cardsCarouselWidget" */ "./widgets/cardsCarouselWidget.js"
    );
    cardsCarousel.default.init(isEditMode);
  }
}

async function testimonialModulesOnDemand(isEditMode) {
  if (document.querySelectorAll(".widget-testimonial").length > 0) {
    const testimonialWidget = await import(
      /* webpackChunkName: "testimonialWidget" */ "./widgets/testimonialWidget.js"
    );
    testimonialWidget.default.init(isEditMode);
  }
}

async function loadWidgetBioProfilesModulesOnDemand(isEditMode) {
  if (document.querySelectorAll(".widget-bio-profiles").length > 0) {
    const bioProfilesWidgetModule = await import(
      /* webpackChunkName: "bioProfilesWidget" */ "./widgets/bioProfilesWidget.js"
    );
    bioProfilesWidgetModule.default.init(isEditMode);
  }
}

export function initSiteWidgets(isEditMode) {
  loadWidgetTextModulesOnDemand(isEditMode);
  loadWidgetBannerCarouselModulesOnDemand(isEditMode);
  loadWidgetBannerCarouselSectionModulesOnDemand(isEditMode);
  loadWidgetCardsModulesOnDemand(isEditMode);
  loadWidgetQuickLinksModulesOnDemand(isEditMode);
  loadWidgetLatestNewsModulesOnDemand(isEditMode);
  loadWidgetFinLitSessionsModulesOnDemand(isEditMode);
  loadWidgetChapterEventsModulesOnDemand(isEditMode);
  loadWidgetSavingsBenefitModulesOnDemand(isEditMode);
  loadWidgetTabsModulesOnDemand(isEditMode);
  loadWidgetThreeTabsModulesOnDemand(isEditMode);
  loadWidgetAccordionModulesOnDemand(isEditMode);
  loadWidgetVideoTabsModulesOnDemand(isEditMode);
  scrollableLinksBackgroundModulesOnDemand(isEditMode);
  cardsCarouselModulesOnDemand(isEditMode);
  testimonialModulesOnDemand(isEditMode);
  loadWidgetBioProfilesModulesOnDemand(isEditMode);
}

async function registerAddScrolledToStickyNav() {
  const addScrolledToStickyNavScript = await import(
    /* webpackChunkName: "addScrolledToStickyNav" */ "./global/addScrolledToStickyNav.js"
  );
  addScrolledToStickyNavScript.default.register();
}

async function registerAddImageFluid() {
  if (document.querySelectorAll(".widget-text").length > 0) {
    const addImageFluidScript = await import(
      /* webpackChunkName: "addImageFluid" */ "./global/addImageFluid.js"
    );
    addImageFluidScript.default.register();
  }
}

async function registerSiteSearch() {
  const siteSearchScript = await import(
    /* webpackChunkName: "siteSearch" */ "./global/siteSearch.js"
  );
  siteSearchScript.default.register();
}

async function registerWrapAccordionItemsScript() {
  if (document.querySelectorAll(".accordion-item").length > 0) {
    const wrapAccordionItemsScript = await import(
      /* webpackChunkName: "wrapAccordionItems" */ "./global/wrapAccordionItems.js"
    );
    wrapAccordionItemsScript.default.register();
  }
}

async function registerOpenAccordionItemFromHashScript() {
  if (document.querySelectorAll(".accordion").length > 0) {
    const openAccordionItemFromHashScript = await import(
      /* webpackChunkName: "openAccordionItemFromHash" */ "./global/openAccordionItemFromHash.js"
    );
    openAccordionItemFromHashScript.default.register();
  }
}

async function registerSideBarNavigationScript() {
    if (document.querySelectorAll(".side-column__nav").length > 0) {
      const sideBarNavigation = await import(
          /* webpackChunkName: "sideBarNavigation" */ "./global/sideBarNavigation.js"
    );
    sideBarNavigation.default.register();
  }
}

async function registeraddExpandAllCallapseAllToAccordionScript() {
  if (document.querySelectorAll(".accordion").length > 0) {
    const addExpandAllCallapseAllToAccordionScript = await import(
      /* webpackChunkName: "addExpandAllCallapseAllToAccordion" */ "./global/addExpandAllCallapseAllToAccordion.js"
    );
    addExpandAllCallapseAllToAccordionScript.default.register();
  }
}

async function registerJumplkinksHandler() {
    const jumplinksHandler = await import("./global/jumplinksHandler.js");
    jumplinksHandler.default.register();
}

async function registerScrollTextAnimationHandler() {
    const scrollTextAnimationHandler = await import("./global/scrollTextAnimationHandler.js");
    scrollTextAnimationHandler.default.register();
}

async function registerReadMoreScript() {
    const readMoreHandler = await import("./global/readMore.js");
    readMoreHandler.default.register();
}

async function registerMegaNav() {
  if (document.querySelectorAll(".mega-nav-host").length > 0) {
    const megaNav = await import(
      /* webpackChunkName: "megaNav" */ "./global/megaNav.js"
    );
    megaNav.default.register();
  }
}

export function initGlobalScripts(isEditMode) {
  registerAddScrolledToStickyNav();
  registerAddImageFluid();
  registerSiteSearch();
  registeraddExpandAllCallapseAllToAccordionScript();
  registerWrapAccordionItemsScript();
  registerOpenAccordionItemFromHashScript();
  registerSideBarNavigationScript();
  registerJumplkinksHandler();
  registerScrollTextAnimationHandler();
  registerReadMoreScript();
  registerMegaNav();
}

(function () {
  if (document.readyState === "loading") {
    const bodyElement = document.body;
    const isEditMode = bodyElement.classList.contains("edit-mode");

    document.addEventListener("DOMContentLoaded", function () {
      if (isEditMode) {
        initSiteWidgets(isEditMode);
      } else {
        initSiteWidgets(false);
      }
      initGlobalScripts();
    });
  }
})();
